
import BaseBlock from '@headlines/utils/BaseBlock';
import BlockTypeSettings from '@headlines/types/block/111-120/blockType115';

const defaultSettings = {};

export default BaseBlock<BlockTypeSettings>(defaultSettings).extend({});
